import messages from '../messages/en.json'

type Params = Record<string, string | number>

// Humanize a key so a missing translation reads as English rather than raw camelCase.
// e.g. "createIssue" → "Create Issue", "fields.subject" → "Subject", "due_date" → "Due Date".
function humanize(key: string): string {
  const last = key.split('.').pop() || key
  return last
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/(?:^|\s)\S/g, c => c.toUpperCase())
}

function resolve(obj: Record<string, any>, key: string): string {
  const parts = key.split('.')
  let cur: any = obj
  for (const part of parts) {
    if (cur == null || typeof cur !== 'object') return humanize(key)
    cur = cur[part]
  }
  return typeof cur === 'string' ? cur : humanize(key)
}

function interpolate(str: string, params?: Params): string {
  if (!params) return str
  return str.replace(/\{(\w+)\}/g, (_, k) => String(params[k] ?? `{${k}}`))
}

export function useTranslations(namespace?: string) {
  const ns = namespace
    ? ((messages as Record<string, any>)[namespace] ?? {})
    : (messages as Record<string, any>)
  return function t(key: string, params?: Params): string {
    return interpolate(resolve(ns, key), params)
  }
}

export const getTranslations = useTranslations
